/* eslint-disable no-param-reassign */
import * as types from '../types';

const topup = {
  state: {
    zhxx: [],
    dzbm: '',
    paykey: '',
    dqdd: {},
  },
  getters: {
    zhxx: state => state.zhxx,
    dzbm: state => state.dzbm,
    paykey: state => state.paykey,
    dqdd: state => state.dqdd,
  },
  mutations: {
    [types.TOPUP_SET_ZHXX]: (state, data) => {
      state.zhxx = data;
    },
    [types.TOPUP_SET_DZBM]: (state, data) => {
      state.dzbm = data;
    },
    [types.TOPUP_SET_PAYKEY]: (state, data) => {
      state.paykey = data;
    },
    [types.TOPUP_SET_DQDD]: (state, data) => {
      state.dqdd = data;
    },
  },
  actions: {},
};

export default topup;



// WEBPACK FOOTER //
// ./src/store/modules/topup.js